import { Link } from '../common';

export interface OpportunityDocumentType {
  opportunityDocumentTypeId: number;
  opportunityDocumentTypeCode: string;
  opportunityDocumentTypeDesc: string;
  link: Link | Link[]; // TODO: Check which one is redundant
  links: Link| Link[];
}
